import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import lodashGet from "lodash/get";
import lodashIsEmpty from "lodash/isEmpty";

import Drawer from "@components/Drawer/Drawer";

import {
  fetchOffers,
  getCartItemsV5,
  getCartItems,
  resetPromocode,
  setPromocode,
} from "./../../actions";
import * as Constants from "../../constants";

import "./styles.scss";
import { connect } from "react-redux";
import OfferCard from "./OfferCard";
import CouponDetail from "./CouponDetail";

class Coupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: false,
      selectedOfferId: null,
      couponCode: '',
      successText: '',
      errorText: '',
      errorMap: {},
      isLoading: false,
      searchQuery: '',
      isApplied: false,
      allOffers: []
    };
  }

  componentDidUpdate(prevProps, prevState) {
    {
      if (
        prevState.isDrawerOpen !== this.state.isDrawerOpen &&
        this.state.isDrawerOpen
      ) {
        this.init();
      }
    }

    {
      const { cart } = this.props;
      const oldCoupon =
        lodashGet(prevProps.cart.data.promotionDetails, "code", "") ||
        lodashGet(prevProps.cart.data.promotionResponse, "promoCode", "");
      const newCoupon =
        lodashGet(cart.data.promotionDetails, "code", "") ||
        lodashGet(cart.data.promotionResponse, "promoCode", "");
      const hasPromocode =
        !lodashIsEmpty(cart.data.promotionDetails) ||
        !lodashIsEmpty(cart.data.promotionResponse);
      if (
        !this.props.customer.omsEnabled &&
        prevProps.cart.data.itemsCount !== cart.data.itemsCount &&
        this.state.couponCode
      ) {
        this.setPromocode();
      }

      if (
        hasPromocode &&
        (oldCoupon !== newCoupon ||
          prevProps.cart.data.itemsCount !== cart.data.itemsCount)
      ) {
        const promotionDetails =
          cart.data.promotionDetails || cart.data.promotionResponse;
        if (promotionDetails.isValid) {
          this.setState({
            couponCode:
              promotionDetails.code ||
              promotionDetails.promoCode ||
              this.state.couponCode,
            successText:
              promotionDetails.description || promotionDetails.disclaimer,
            errorText: "",
            errorMap: {},
            isApplied: true,
          });
        } else {
          this.setState({
            couponCode:
              promotionDetails.code ||
              promotionDetails.promoCode ||
              this.state.couponCode,
            successText: "",
            errorText:
              promotionDetails.disclaimer || promotionDetails.message || "",
            errorMap: {
              [promotionDetails.code ||
              promotionDetails.promoCode ||
              this.state.couponCode]:
                promotionDetails.disclaimer || promotionDetails.message,
            },
            isApplied: false,
          });
        }
      } else if (!hasPromocode && oldCoupon) {
        if (this.props.customer.omsEnabled) {
          this.fetchCartV5();
        }
      }
    }

    {
      const searchQuery = this.state.searchQuery;
      const { offers } = this.props;
      const prevPropsOffers = [...prevProps.offers.active, ...prevProps.offers.expired];
      const newPropsOffers = [...offers.active, ...offers.expired];
      if ((prevState.searchQuery !== searchQuery) || (prevPropsOffers.length !== newPropsOffers.length)) {
        const allOffers = [...offers.active, ...offers.expired].filter(
          (_offer) =>
            searchQuery
              ? _offer.promoCode &&
                _offer.promoCode
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())
              : true
        );
        this.setState({
          allOffers,
        });
      }
    }
  }

  onApply = offer => {
    if (!this.props.canApply) {
      return;
    }
    this.applyPromocode(offer.promoCode);
  };

  getOrderType = () => {
    const { data } = this.props.cart ? this.props.cart : {};
    let orderType = Constants.PromotionOrderTypeMapping.medicineOrder;

    if (data && data.itemsCount > 0) {
      const healthcareItems = (data.healthcare && data.healthcare.items) || [];
      const medicineItems = (data.medicine && data.medicine.items) || [];

      if (healthcareItems.length > 0) {
        orderType = Constants.PromotionOrderTypeMapping.atcOrder;
      }
      // this sequence is important
      // if only medicines are present, it is medicine order
      // if only healthcare items are present, it is otc order
      // if both are present, atc order
      if (medicineItems.length < 1) {
        orderType = Constants.PromotionOrderTypeMapping.otcOrder;
      }
    }

    return orderType;
  };

  setPromocode = coupon => {
    this.props
      .setPromocode({
        code: coupon || this.state.couponCode,
        orderType: this.getOrderType(),
      })
      .then(
        ({
          status,
          data: { message: successText = '', summary } = {},
          error: { message: errorText = '' } = {},
        }) => {
          if (status === 0) {
            this.props.resetPromocode();
          } else if (status !== 0 || this.state.allOffers.length === 0) {
            this.closeDrawer();
          }
          const obj = {
            couponCode: coupon || this.state.couponCode,
            errorText,
            successText: summary || successText,
            isApplied: !!status,
            errorMap: {},
          };
          if (errorText) {
            obj.errorMap[obj.couponCode] = errorText;
          }
          this.setState(obj);
        }
      )
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  fetchCartV5 = (code) => {
    const params = {};

    if (code && code.length > 0) {
      params.promoCode = code;
    }

    this.setState({
      isLoading: true,
    });

    this.props
      .getCartItemsV5(params)
      .then(res => {
        if ((res.promotionDetails && res.promotionDetails.isValid)) {
          this.closeDrawer();
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  handleOfferClick = offerId => {
    this.setState({
      selectedOfferId: offerId,
    });
  };

  openDrawer = () => {
    this.setState({
      isDrawerOpen: true,
    });
  };

  closeDrawer = () => {
    this.setState({
      isDrawerOpen: false,
      searchQuery: '',
    });
  };

  init = () => {
    this.setState({
      isLoading: true,
    });
    this.props.fetchOffers().finally(() => {
      this.setState({
        isLoading: false,
      });
    });
  };

  handleCustomApply = () => {
    if (!this.props.canApply) {
      return;
    }
    const {
      allOffers,
      couponCode,
      searchQuery,
    } = this.state;

    if (allOffers.length === 0 && couponCode === searchQuery) {
      this.handleClearClick();
    } else {
      this.applyPromocode(this.state.searchQuery);
    }
  }

  handleClearClick = () => {
    this.setState({
      searchQuery: '',
      errorText: '',
      errorMap: {},
    });
    this.handleRemoveCode();
  }

  applyPromocode = (coupon = '') => {
    if (this.state.isLoading) {
      return;
    }

    if (this.props.customer.omsEnabled) {
      this.fetchCartV5(coupon);
    } else {
      this.setState({
        isLoading: true,
      });
      this.setPromocode(coupon);
    }
  };

  handleRemoveCode = () => {
    this.props.resetPromocode();
    if (!this.props.customer.omsEnabled) {
      this.props.getCartItems();
    }
    this.setState({
      couponCode: "",
      isApplied: false,
      errorText: "",
      errorMap: {},
      successText: "",
      selectedOfferId: null,
    });
  };

  handleSearchChange = e => {
    this.setState({
      searchQuery: e.target.value.toUpperCase().trim(),
    });
  };

  render() {
    const {
      isDrawerOpen,
      selectedOfferId,
      couponCode,
      errorText,
      errorMap,
      successText,
      isLoading,
      searchQuery,
      isApplied,
      allOffers
    } = this.state;

    const { canApply, position } = this.props;

    return (
      <div className={cx("couponContainer", {})}>
        <div className="btnContainer">
          {canApply && (!!couponCode || !!errorText) && (
            <div className="appliedCoupon">
              <div className="code">{couponCode}</div>
              <div className="removeBtn" onClick={this.handleRemoveCode}>
                Remove
              </div>
            </div>
          )}
          <div className="couponAndOffersBtn" onClick={this.openDrawer}>
            <img src={require("@images/green_star.svg")} alt="coupon" />
            {"Coupons & Offers"}
          </div>
        </div>
        {(!!errorText || !!successText) && (
          <div className={errorText ? "error" : "success"}>
            {errorText || successText}
          </div>
        )}
        <Drawer
          open={isDrawerOpen}
          onClose={!isLoading ? this.closeDrawer : null}
          isBackDropDismissable
          position={position}
        >
          <div
            className={cx("couponDrawerContainer", {
              "pe-loading": isLoading,
            })}
          >
            <div className="header">{"Coupons & Offers"}</div>
            <div className="content">
              <div className="left">
                <div className="searchContainer">
                  <img src={require("@images/search.png")} alt="search" />
                  <input
                    placeholder="Search a coupon"
                    onChange={this.handleSearchChange}
                    onKeyDown={e => e.key === 'Enter' && allOffers.length === 0 && this.handleCustomApply()}
                    value={searchQuery}
                  />
                  {
                    canApply && allOffers.length === 0 && couponCode !== searchQuery && <div className="applyBtn" onClick={this.handleCustomApply}>APPLY</div>
                  }
                  {
                    canApply && allOffers.length === 0 && couponCode === searchQuery && <div className="applyBtn clearBtn" onClick={this.handleClearClick}>CLEAR</div>
                  }
                </div>
                {!!errorText && couponCode === searchQuery && <div className="searchError">{errorText || errorMap[couponCode]}</div>}
                <div className="offersList">
                  {allOffers.map(offer => (
                    <OfferCard
                      key={offer.id}
                      offer={offer}
                      canApply={canApply}
                      handleOfferClick={this.handleOfferClick}
                      selectedOfferId={selectedOfferId}
                      appliedCouponCode={isApplied ? this.state.couponCode : ""}
                      onApply={() => this.onApply(offer)}
                      error={errorMap[offer.promoCode]}
                    />
                  ))}
                  {allOffers.length === 0 && !!searchQuery && (
                    <div className="searchCustomCard">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${Constants.CMS_URL}/coupon/search?q=${searchQuery}`}
                      >
                        Not applicable - View more details on CMS
                      </a>
                    </div>
                  )}
                </div>
              </div>
              <div className="right">
                <div className="couponDetailsHeading">
                  <strong>Coupon Details</strong>
                </div>
                <CouponDetail
                  detail={allOffers.find(
                    (offer) => offer.id === selectedOfferId
                  )}
                  canApply={canApply}
                  onApply={this.onApply}
                  appliedCouponCode={isApplied ? this.state.couponCode : ""}
                  errorMap={errorMap}
                />
              </div>
            </div>
          </div>
        </Drawer>
      </div>
    );
  }
}

Coupon.propTypes = {
  fetchOffers: PropTypes.func.isRequired,
  getCartItemsV5: PropTypes.func.isRequired,
  getCartItems: PropTypes.func.isRequired,
  resetPromocode: PropTypes.func.isRequired,
  setPromocode: PropTypes.func.isRequired,
  offers: PropTypes.object.isRequired,
  canApply: PropTypes.bool,
  position: PropTypes.string,
  cart: PropTypes.object,
  customer: PropTypes.object,
};

Coupon.defaultProps = {
  canApply: false,
  position: "right",
  cart: {},
  customer: {},
};

const mapStateToProps = (state) => {
  return {
    offers: state.coupon.offers,
    cart: state.cart,
    customer: state.customer,
  };
};

const mapDispatchToProps = {
  fetchOffers,
  getCartItemsV5,
  getCartItems,
  resetPromocode,
  setPromocode,
};

export default connect(mapStateToProps, mapDispatchToProps)(Coupon);
